import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import './CoCreateCTA.css';

const CoCreateCTA = () => {
  return (
    <section className="co-create-cta-section">
      <div className="co-create-cta-container">
        <h2>Let's co-create your next move</h2>
        <p>
          Whether you are expanding into new markets, strengthening core business or preparing for disruption - our joint consulting practice is built to support your vision.
        </p>
        <div className="cta-logo-placeholder">
          quesrow
        </div>
        <Link to="/consulting">
          <button className="cta-explore-btn">
            Explore our consulting services <FiArrowRight />
          </button>
        </Link>
      </div>
    </section>
  );
};

export default CoCreateCTA;